import { render, staticRenderFns } from "./ShareVideo.vue?vue&type=template&id=8136ca84&scoped=true"
import script from "./ShareVideo.vue?vue&type=script&lang=js"
export * from "./ShareVideo.vue?vue&type=script&lang=js"
import style0 from "./ShareVideo.vue?vue&type=style&index=0&id=8136ca84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8136ca84",
  null
  
)

export default component.exports